export const storeToken = (token) => {
    localStorage.setItem('tokenexpense', token);
  };

  export const getToken = () => {
    return localStorage.getItem('tokenexpense');
  };

  export const clearAuthData = () => {
    localStorage.removeItem('tokenexpense');
  };